export const layerFilters = [
  { value: "all", title: "Все" },
  { value: "active", title: "Активные" },
  { value: "nonactive", title: "Неактивные" }
];

export const customFilter = function(state, node, value) {
  const name = node.name || "";
  let isFind;

  if (state.module === "mapTree") {
    switch (state.layerFilter) {
      case "active":
        isFind =
          name.toLowerCase().indexOf(value.toLowerCase()) >= 0 &&
          state.isActive(node.id);
        break;
      case "nonactive":
        isFind =
          name.toLowerCase().indexOf(value.toLowerCase()) >= 0 &&
          !state.isActive(node.id);
        break;
      default:
        isFind = name.toLowerCase().indexOf(value.toLowerCase()) >= 0;
        break;
    }
  } else {
    isFind = name.toLowerCase().indexOf(value.toLowerCase()) >= 0;
  }

  if (value && isFind) state.expandToNode(node.id);

  return isFind;
};

export const preventDefaultEvent = function(e) {
  e.preventDefault();
};

export const stopPropagationEvent = function(e) {
  e.stopPropagation();
};

export const clickHandler = function(state, e) {
  let target = e.target || e.srcElement;
  let data = {
    name: target.getAttribute("node-name"),
    id: target.getAttribute("data-id"),
    geomType: target.getAttribute("geom-type"),
    datatype: target.getAttribute("data-type"),
    children: parseInt(target.getAttribute("children"), 10),
    source_id: target.getAttribute("data-source-id")
  };
  const currentNode = state.tree.getNodeById(data.id);
  state.removeTooltip();

  switch (target.getAttribute("node-type")) {
    case "settings":
      state.toggleLayersSettings(e, data);
      break;
    case "book":
      state.toggleLayersBook(e, data);
      break;
    case "editor":
      state.toggleLayersEditor(e, data);
      break;
    case "flytolayer":
      state.flyToLayerHandler(e, data);
      break;
    case "enablerouter":
      state.enableRouterHandler(e, data);
      break;
    case "startcalc":
      state.startCalcHandler(e, data);
      break;
    case "export":
      state.openDsExport(e, data);
      break;
    case "rename":
      state.enterRenameMode(data.id);
      break;
    case "toggler":
      state.togglerHandler(data.id);
      break;
    case "title":
      if (state.renameModeNodeId) return;
      if (state.editMode) {
        state.checkNodes(currentNode);
        state.$store.commit("UPDATE_CHECKED_DATA", {
          checkedData: state.checkedNodes,
          isProfile: state.module === "constructorTree" ? true : false
        });
        setTimeout(() => state.tree.filter(state.filterText), 10);
      } else if (state.nodeClickHandler) {
        state.nodeClickHandler(e, data);
      }
      break;
    default:
      state.nodeClickHandler(e, data);
      break;
  }
};
